export type FeatureChangeType = 'new' | 'updated';

export type FeatureTourAdvanceOn = 'anchor-click';

export interface FeatureTourStep {
  selector: string;
  title: string;
  description: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  optional?: boolean;
  advanceOn?: FeatureTourAdvanceOn;
}

export interface FeatureTourReadiness {
  routeKey?: string;
  source?: FeatureTourReadinessSource;
  waitForNetworkIdle?: boolean;
  graphql?: FeatureGraphqlCacheRequirement[];
}

export interface FeatureTourReadinessSource {
  stateKey: string;
  loadingPaths: string[];
  loadedPaths: string[];
  errorPaths: string[];
  dataPaths: string[];
}

export type FeatureTourReadinessStatus = 'loading' | 'ready' | 'unavailable';

export interface FeatureGraphqlCacheRequirement {
  clientName: string;
  fieldName: string;
  requiredPath?: string;
  requireNonEmpty?: boolean;
}

export interface FeatureAnnouncement {
  featureKey: string;
  title: string;
  description: string;
  sidebarTitle?: string;
  sidebarHighlights?: FeatureAnnouncementHighlight[];
  changeType: FeatureChangeType;
  publishedAt: string;
  expiryDate?: string;
  hasTour: boolean;
  ctaLabel?: string;
  route?: string;
  readiness?: FeatureTourReadiness;
  navBadgeTarget?: string;
  badgeTargets?: FeatureAnnouncementBadgeTarget[];
  badgeTooltip?: string;
  tourSteps?: FeatureTourStep[];
}

export interface FeatureAnnouncementBadgeTarget {
  selector: string;
  tooltip?: string;
}

export interface FeatureAnnouncementHighlight {
  title: string;
  description: string;
}

export interface FeatureInteraction {
  seenAt: string;
  tourCompleted: boolean;
}

export type FeatureInteractions = Record<string, FeatureInteraction>;
